// 空状态: 插画 + 三个大按钮
import { makeT, type Lang } from '../lib/i18n';

export function EmptyState({ lang, onPick, onCapture }: { lang: Lang; onPick: () => void; onCapture: () => void }) {
  const t = makeT(lang);
  return (
    <div className="empty">
      <div className="emoji">📷</div>
      <h2>{t('empty.title')}</h2>
      <p>{t('empty.subtitle')}</p>
      <div className="btns">
        <button className="btn primary" onClick={onPick}>➕ {t('empty.file')}</button>
      </div>
    </div>
  );
}
